import { Lock } from "lucide-react";
import { Link, useLocation } from "react-router";

import { cn } from "~/lib/utils";

/** One episode in a grid. Every chip links to the player, locked or not: the player is where the
 *  sign-in and paywall gates live, so a locked chip leads to them rather than to nothing. */
export function EpisodeChip({
  id,
  seriesId,
  number,
  locked,
  playing = false,
  replace = false,
  onClick,
  className,
}: {
  id: string;
  seriesId: string;
  number: number;
  locked: boolean;
  playing?: boolean;
  /** Inside the player, so moving between episodes does not stack history entries. */
  replace?: boolean;
  onClick?: () => void;
  className?: string;
}) {
  // The page's own parameters come along, a campaign's among them: later events are attributed by
  // them. Only `t` is dropped, since it belongs to the episode the link that carried it named.
  const params = new URLSearchParams(useLocation().search);
  params.set("series", seriesId);
  params.set("ep", String(number));
  params.delete("t");

  return (
    <Link
      id={id}
      to={`/cinema/watch?${params}`}
      replace={replace}
      onClick={onClick}
      aria-label={locked ? `Episode ${number}, locked` : `Episode ${number}`}
      aria-current={playing ? "true" : undefined}
      className={cn(
        "flex h-[56px] flex-col items-center justify-center gap-[2px] rounded-[8px] text-[15px] leading-[18px]",
        playing
          ? "bg-brand-500 font-bold text-neutral-900"
          : locked
            ? "border border-neutral-800 bg-neutral-900 font-semibold text-neutral-500"
            : "bg-neutral-800 font-semibold text-neutral-50",
        className
      )}
    >
      {number}
      {locked && !playing && <Lock className="size-[11px]" />}
    </Link>
  );
}
